/**
 * Calculate current BMI using Imperial measures
 */
export function calculateBMIImperial(
  heightFeet: number,
  heightInch: number,
  currentWeight: number
) {
  const heightInInch = heightInch + heightFeet * 12;
  return (currentWeight / (heightInInch * heightInInch)) * 703;
}

/**
 * Calculate current BMI using Metric measures
 */
export function calculateBMIMetric(heightCm: number, currentWeightKg: number) {
  const heightInMeter = heightCm / 100;
  return currentWeightKg / (heightInMeter * heightInMeter);
}

/**
 * Calculate weight in imperial units from a BMI value and height in imperial units
 * This is the inverse of the formula from calculateTargetBMIImperial
 * <=> (targetBMI / 703) * (heightInInch * heighInInch) = targetWeight
 */
export function calculateImperialWeightFromBMI(
  heightFeet: number,
  heightInch: number,
  bmi: number
) {
  const heightInInch = heightInch + heightFeet * 12;
  const weight = (bmi / 703) * (heightInInch * heightInInch);
  return Math.round(weight);
}

/**
 * Calculate weight in metric units from a BMI value and height in metric units
 * <=> bmi * (heightInMeters^2) = targetWeight
 */
export function calculateMetricWeightFromBMI(height: number, bmi: number) {
  const heightInMeters = height / 100;
  return Math.round(bmi * (heightInMeters * heightInMeters));
}
